<div class="content">
  <h2 class="title">Tareas a generar</h2>
  <mat-icon class="close-modal" (click)="closeModal()">close</mat-icon>
  <div *ngIf="tasks.length == 0 && taskSelected.length == 0">
    <h2 class="advice">Todas las tareas han sido generadas</h2>
  </div>
  <ng-container *ngIf="taskSelected.length > 0">
    <div class="container">
      <div class="row">
        <div class="col-4 taskcol" *ngFor="let task of taskSelected">
          <task-case-card
            class="selected"
            (click)="removeFromSelected(task)"
            [task]="task"
          ></task-case-card>
        </div>
      </div>
    </div>
    <div class="btn-c">
      <button
        (click)="addTasks()"
        mat-fab
        color="warn"
        aria-label="Example icon button with a home icon"
      >
        <mat-icon>check</mat-icon>
      </button>
    </div>

    <div class="divisor"></div>
  </ng-container>
  <div class="container">
    <div class="row">
      <div class="col-4 taskcol" *ngFor="let task of tasks">
        <task-case-card
          (click)="addToSelected(task)"
          [task]="task"
        ></task-case-card>
      </div>
    </div>
  </div>
</div>
